import { mvbSubscriptionPlanApiBase as api } from './mvbSubscriptionPlanApiBase';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    mySubscriptionControllerGetMySubscriptionPlan: build.query<
      MySubscriptionControllerGetMySubscriptionPlanApiResponse,
      MySubscriptionControllerGetMySubscriptionPlanApiArg
    >({
      query: () => ({ url: `/api/me/subscription/plan` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as mvbSubscriptionPlanApiInjected };
export type MySubscriptionControllerGetMySubscriptionPlanApiResponse =
  /** status 200  */ SubscriptionPlan;
export type MySubscriptionControllerGetMySubscriptionPlanApiArg = void;
export type SubscriptionPlan = {
  message: string;
};
export type ErrorSchema = {
  status: number;
  responseCode: number;
  messageCode: number;
  message: string;
};
export const { useMySubscriptionControllerGetMySubscriptionPlanQuery } =
  injectedRtkApi;
